<!--
 * @Author: Haotao
 * @Date: 2022-09-01 14:53:38
 * @LastEditors: Haotao
-->
<!--  -->
<template>
  <div class="chat" @click="handleGotoConcat">

  </div>
</template>

<script>
import { getChatUrl } from '@api/user';
export default {
  data() {
    return {
    }
  },
  methods: {
    handleGotoConcat() {
      // getChatUrl({}).then(res => {
      //   if (res.code === 200 && res.data) {
      //     window.location.href = res.data;
      //   }
      // })
    }
  }
}
</script>
<style lang='less' scoped>
.chat {
  width: 16vw;
  height: 16vw;
  border-radius: 50%;
  // background-color: #5eaafe;
  position: fixed;
  top: 3vh;
  right: 3vw;
  z-index: 1000;
  background-image: url('./../assets/images/login/customer.png');
  background-size: 80% 80%;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
